import { centerAlignColDef, defaultColDef, floatFormater, leftAlignColDef, rightAlignColDef } from "../../../components/grid/columnDefinitions/columnDefinitions";
import { Corporate } from "../../../db_access/corporate";
import OrganizationCommonDashboard from "../OrganizationCommonDashboard";

const CorporateDashboard = () => {
  const columnDefs = [
    {
      headerName: "Name",
      field: "name",
      cellEditor: "agTextCellEditor",
      ...defaultColDef,
      ...leftAlignColDef,
      editable: true,
    },
    {
      headerName: "Location",
      field: "location",
      cellEditor: "agTextCellEditor",
      ...defaultColDef,
      ...centerAlignColDef,
      editable: true,
    },
    {
      headerName: "Year",
      field: "year",
      cellEditor: "agNumberCellEditor",
      ...defaultColDef,
      ...centerAlignColDef,
      editable: true,
    },
    {
      headerName: "GWP (kg)",
      field: "gwp",
      cellEditor: "agTextCellEditor",
      ...defaultColDef,
      ...rightAlignColDef,
      ...floatFormater,
    },
    {
      headerName: "Cost",
      field: "cost",
      cellEditor: "agNumberCellEditor",
      ...defaultColDef,
      ...rightAlignColDef,
      ...floatFormater,
      editable: true,
    },
  ];
  return (
    <OrganizationCommonDashboard
      organization={Corporate}
      colDefs={columnDefs}
      title={"Corporate"}
      subtitle={"Corporate"}
      tabletitle={"Corporate"}
      pageType={"corporate"}
      colVisibility_key={"corporate_dashboard_table_column_visibility"}
    />
  );
};
export default CorporateDashboard;
